import { Injectable } from '@angular/core';
import { EntityLogInfo } from '../logs/entity-log-info';
import { Observable } from 'rxjs';
import { User } from '../company/company';
import { HttpClient } from '@angular/common/http';
import { DefinedPaths } from '../../constants/defined-paths';
import { BaseRepository } from '../base-repository';
import { Apollo } from 'apollo-angular';
import {ADD_USER, GET_USER, GET_USERS, UPDATE_USER} from './user.queries';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserRepository extends BaseRepository<User> {
  constructor(
    apollo: Apollo,
    private http: HttpClient,
    private paths: DefinedPaths
  ) {
    super(apollo, GET_USERS);
  }

  override get(id: string): Observable<User> {
    return this.apollo
      .watchQuery<{ user: User }>({
        query: GET_USER,
        variables: { id },
      })
      .valueChanges.pipe(map((result) => result.data.user));
  }

  override getAll(): Observable<User[]> {
    return this.apollo
      .watchQuery<{ users: User[] }>({
        query: GET_USERS,
      })
      .valueChanges.pipe(map((result) => result.data.users));
  }

  override update(
    data: Partial<User>,
    logInfo: EntityLogInfo
  ): Observable<Partial<User>> {
    return this.apollo
      .mutate<{ updateUser: User }>({
        mutation: UPDATE_USER,
        variables: { user: data, logInfo },
        refetchQueries: [GET_USERS],
      })
      .pipe(
        map((result) => {
          if (result.data?.updateUser) return result.data.updateUser;
          throw new Error('Failed to Update User');
        })
      );
  }

  override delete(id: string, logInfo: EntityLogInfo): Observable<boolean> {
    throw new Error('Method not implemented.');
  }
  override create(
    user: Partial<User>,
    logInfo: EntityLogInfo
  ): Observable<Partial<User>> {
    return this.http.post<Partial<User>>(this.paths.UserCompanyEndpoint, {
      user,
      logInfo,
    });
  }

  //create with graphql
  createUser(user: Partial<User>, logInfo: EntityLogInfo): Observable<Partial<User>> {
    return this.apollo.mutate<{ addUser: User }>({
      mutation: ADD_USER,
      variables: { user, logInfo },
      refetchQueries: [GET_USERS],
    }).pipe(
      map((result) => {
        if (result.data?.addUser) return result.data.addUser;
        throw new Error('Failed to Create User');
      })
    );
  }
}
